import { ApolloClientProvider } from 'components/_global/app/apollo-client';
import { GlobalStatusesProvider } from 'components/_global/app/global-statuses';
import { VodapayProvider } from 'components/_global/app/vodapay';
import type { ReactNode } from 'react';

const AppProviders = ({ children }: { children: ReactNode }) => (
  <ApolloClientProvider>
    <VodapayProvider>
      <GlobalStatusesProvider>{children}</GlobalStatusesProvider>
    </VodapayProvider>
  </ApolloClientProvider>
);

export default AppProviders;
